export const ESubscriptionType = {
  New: 'NewSubscription',
  ReSubscription: 'ReSubscription',
} as const;

export const EClientType = { INDIVIDUAL: 'individual', COMPANY: 'company' } as const;

export const EOperator = { ENEDIS: 'enedis' } as const;
export const EProvider = { MYL: 'MYLIGHT150', DOMUNEO: 'DOMUNEO' } as const;

export const EClientEquipement = {
  SOLAR_FIELD: 'SolarField',
  HVAC_AIR_TO_WATER: 'HvacAirToWater',
  WATER_HEATER: 'WaterHeater',
  E_V_CHARGER: 'EVCharger',
} as const;

export const EBatteryOptionAvailable = { MSB: 'MsbOption', MB: 'MyBatteryOption' } as const;
export const EBatteryOptionSelectable = { ...EBatteryOptionAvailable, NONE: 'None' } as const;
export const EEquipmentControlOption = {
  MSC: 'MscOption',
  MSP: 'MspOption',
  MSH: 'MshOption',
} as const;

export const EHeatingSystemOption = {
  GAZ_BOILER: 'GazBoiler',
  FUEL_OIL: 'FuelOil',
  WOOD: 'Wood',
  HEAT_PUMP: 'HeatPump',
  NEW_INSTALLATION: 'NewInstallation',
  I_DONT_KNOW: 'IDontKnow',
} as const;

export const EDomesticHotWaterOption = {
  HEAT_PUMP: 'HeatPump',
  ELECTRIC_BALLOON: 'ElectricBalloon',
  BALLOON: 'Balloon',
  OTHER: 'Other',
  I_DONT_KNOW: 'IDontKnow',
};

export const ESubscriptionPricingOptionType = {
  Base: 'Base',
  OffPeakAndPeakHours: 'OffPeakAndPeakHours',
  ExtendedOffPeakAndPeakHours: 'ExtendedOffPeakAndPeakHours',
} as const;

export const EWelcomeOfferPrices = {
  Base6KvaOrLess: { discounted: '0,2001', standard: '0,2336' },
  BaseMoreThan6Kva: { discounted: '0,1985', standard: '0,2320' },
  PeakHours: { discounted: '0,2142', standard: '0,2540' },
  OffPeakHours: { discounted: '0,1589', standard: '0,1900' },
} as const;

export const EDirectDebitMode = {
  LINEAR: 'Linear',
  REALTIME: 'Realtime',
} as const;

export const EMainHeatingSource = {
  AirToWaterHeatPump: 'AirToWaterHeatPump',
  AirToAirHeatPump: 'AirToAirHeatPump',
  ElectricRadiators: 'ElectricRadiators',
  NoElectric: 'NoElectric',
} as const;

export const EWaterHeatingSource = {
  ElectricWaterHeater: 'ElectricWaterHeater',
  ThermodynamicWaterHeater: 'ThermodynamicWaterHeater',
  HeatPump: 'HeatPump',
  NoElectric: 'NoElectric',
} as const;

export const EOtherEquipment = {
  AirConditioning: 'AirConditioning',
  Fireplace: 'Fireplace',
  ElectricalVehicle: 'ElectricalVehicle',
  HybridVehicle: 'HybridVehicle',
  SwimmingPool: 'SwimmingPool',
  Spa: 'Spa',
} as const;

export const EEquipmentInstallationStatus = {
  ALREADY_EQUIPPED: 'AlreadyEquipped',
  PLANNED_INSTALLATION: 'PlannedInstallation',
  NOT_EQUIPPED: 'NotEquipped',
} as const;

export const EPhysicalBatteryName = {
  ATMOCE: 'Atmoce',
  ENPHASE_ACB: 'EnphaseAcb',
  ENPHASE_OTHER: 'EnphaseOther',
  FOX: 'Fox',
  HUAWEI: 'Huawei',
  SOLPLANET: 'Solplanet',
  TESLA: 'Tesla',
  OTHER: 'Other',
} as const;

export const EInstallationPerformer = {
  PROFESSIONAL_INSTALLER: 'ProfessionalInstaller',
  SELF_INSTALLED: 'SelfInstalled',
} as const;

export const EAnnualConsumptionUnit = {
  KILOWATT_HOURS: 'kilowattHours',
  EUROS: 'euros',
} as const;

export const AIR_TO_WATER_HEAT_PUMP_ANNUAL_CASHBACK = 250;
export const ELECTRIC_WATER_HEATER_ANNUAL_CASHBACK = 100;
export const EV_CHARGER_ANNUAL_CASHBACK = 150;

export const PHYSICAL_BATTERY_MIN_CAPACITY_KWH = 1;
